module.exports = __webpack_public_path__ + "img/php.4daf56de.png";